import React, { PropTypes } from 'react';
import classnames from 'classnames';
import i18n from '../../libs/i18n';

import Button from '../Button.jsx';

export default class GalleryItem extends React.Component {
  static propTypes = {
    image: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
  };
  static defaultProps = {};

  render() {
    const { children, image, description, link, onClick } = this.props;

    const styles = {
      wrapper: classnames({
        'gallery--item': true,
        'gallery--item--clickable': onClick !== undefined,
      }),
      content: classnames('gallery--item--content'),
      caption: classnames('gallery--item--caption'),
      captionText: classnames('gallery--item--caption--text'),
      captionLink: classnames('gallery--item--caption--link'),
    };

    const inlineStyles = {
      content: {
        backgroundImage: `url(${image})`,
      },
    };

    const captionLink = (link) ? (
      <div className={styles.captionLink}>
        <Button
          color="red"
          size="small"
          icon="download"
          block
          blank
          link={link}
        >{i18n.translate('newProducts.link')}</Button>
      </div>
    ) : null;

    return (
      <div className={styles.wrapper} onClick={onClick}>
        <div className={styles.content} style={inlineStyles.content}>
          {children}
          {description &&
            <div className={styles.caption}>
              <div className={styles.captionText}>{i18n.translate(description)}</div>
              {captionLink}
            </div>}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Gallery/GalleryItem.jsx
 **/